import {AutomationList} from "./../../models/AutomationList";
import {AutomationListScheduledTrigger} from "../../models/AutomationListScheduledTrigger";

let automationListsApi = {
    async get(filters, page=1, token, companyId, fields=null, relationships= ['category:id,name', 'filters.subfilters', 'outFilters.subfilters', 'triggers', 'integrations', 'users']){
        let response = await window.axios.get('/api/automation-lists', {
            params:{
                api_token:token,
                company_logged:companyId,
                page: page,
                fields: fields,
                relationships: relationships,
                ...filters
            }
        });

        //map data into model (paginated and list)
        let dataMap = data=>data.map(it=>new AutomationList(it))
        if(response.data.current_page)
            response.data.data = dataMap(response.data.data);
        else
            response.data = dataMap(response.data);

        return response.data;
    },
    async find(id, token, companyId, fields= null, relationships= ['category:id,name', 'filters.subfilters', 'outFilters.subfilters', 'clients:id,name,email', 'triggers.scheduledTrigger', 'integrations', 'users']){
        let response = await window.axios.get('/api/automation-lists/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                fields: fields,
                relationships: relationships,
            }
        });
        return new AutomationList(response.data);
    },
    async create(automationList, token, companyId){
        let response = await window.axios.post('/api/automation-lists', automationList, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new AutomationList(response.data);
    },
    async edit(automationList, token, companyId){
        let response = await window.axios.put('/api/automation-lists/'+automationList.id, automationList, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new AutomationList(response.data);
    },
    async delete(automationList, token, companyId){
        let response = await window.axios.delete('/api/automation-lists/'+automationList.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async downloadContactsSheet(automationList, token, companyId){
        let response = await window.axios.get('/api/automation-lists/'+automationList.id+'/contacts-sheet', {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.url;
    },
    async downloadTriggersSheet(automationList, token, companyId){
        let response = await window.axios.get('/api/automation-lists/'+automationList.id+'/triggers-sheet', {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.url;
    },
    async fireTriggerHook(id, triggerId, token, companyId) {
        let response = await window.axios.post('/api/automation-lists/'+id+'/fire-trigger-hook/'+triggerId, null, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.success;
    },
    async createScheduledTrigger(id, triggerId, triggerAt, token, companyId) {
        let response = await window.axios.post('/api/automation-lists/'+id+'/create-scheduled-trigger/'+triggerId, {
            trigger_at: triggerAt
        }, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new AutomationListScheduledTrigger(response.data);
    },
    async removeScheduledTrigger(id, triggerId, token, companyId) {
        let response = await window.axios.delete('/api/automation-lists/'+id+'/remove-scheduled-trigger/'+triggerId, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.success;
    },
    async createAdsIntegration(automationList, adsType, token, companyId){
        let response = await window.axios.post('/api/automation-lists/'+automationList.id+'/create-ads-integration/'+adsType, null, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new AutomationList(response.data);
    },
    async deleteAdsIntegration(automationList, adsType, token, companyId){
        let response = await window.axios.delete('/api/automation-lists/'+automationList.id+'/delete-ads-integration/'+adsType, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new AutomationList(response.data);
    },
    async syncContacts(automationList, token, companyId){
        let response = await window.axios.post('/api/automation-lists/'+automationList.id+'/sync-contacts', null,{
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.success;
    }
}

export default automationListsApi